module.exports = __webpack_public_path__ + "img/kerstboom.bf9a9f6b.png";